enum DialogType {
    YES_NO = "yes_no",
    OK = "ok"
}

export default DialogType